export class CreateGraphInput {
    'title';
    'chartType';
    'sqlQuery';
    'columnMapping';
    'layout';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "chartType",
            "baseName": "chartType",
            "type": "CreateGraphInputChartTypeEnum",
            "format": ""
        },
        {
            "name": "sqlQuery",
            "baseName": "sqlQuery",
            "type": "string",
            "format": ""
        },
        {
            "name": "columnMapping",
            "baseName": "columnMapping",
            "type": "{ [key: string]: any; }",
            "format": ""
        },
        {
            "name": "layout",
            "baseName": "layout",
            "type": "DashboardGraphLayout",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateGraphInput.attributeTypeMap;
    }
    constructor() {
    }
}
export var CreateGraphInputChartTypeEnum;
(function (CreateGraphInputChartTypeEnum) {
    CreateGraphInputChartTypeEnum["Bar"] = "BAR";
    CreateGraphInputChartTypeEnum["Line"] = "LINE";
    CreateGraphInputChartTypeEnum["Pie"] = "PIE";
    CreateGraphInputChartTypeEnum["Area"] = "AREA";
    CreateGraphInputChartTypeEnum["Scatter"] = "SCATTER";
    CreateGraphInputChartTypeEnum["Donut"] = "DONUT";
    CreateGraphInputChartTypeEnum["Table"] = "TABLE";
})(CreateGraphInputChartTypeEnum || (CreateGraphInputChartTypeEnum = {}));
